module.exports = __webpack_public_path__ + "img/friendly-pool-5.b0d46b3b.jpg";